// extracted by mini-css-extract-plugin
export default {"cta":"Naa","grey":"Oaa","dark":"Paa","chip":"Qaa","card":"Raa","nonclickable":"Saa","top":"Taa","left":"Uaa","span":"Vaa","name":"Waa"};
    if(module.hot) {
      // 1738064244312
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  